<div class="variant-detail-image-wrapper variant-detail-image-wrapper-inner" v-if="image" :style="{'background-image': 'url('+image+')'}"></div>